import { useParams } from 'react-router-dom';
import { useCallback, useRef, useState } from 'react';
import { Row, Space, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import useRegisterGuest from 'hooks/useRegiterGuest';
import { Button } from 'antd-mobile';
import useOnFetch from '../../../../hooks/useOnFetch';
import useTranslations from '../../../../hooks/useTranslations';
import NotifResult from '../../../../components/global/NotifResult';
import { convertDateTimeToUnixTimestamp } from '../../../../helpers/convertDateToUnix';
import Drawer from '../../../../components/drawer';
import ModalSuccessBooking from './ModalSuccessBooking';

const { Text } = Typography;

function BookingConfirmation({ onClose, visible, formInstance }) {
    const { t } = useTranslations();
    const fetch = useOnFetch();
    const { masseusesId } = useParams();
    const { refreshGuestId } = useRegisterGuest();

    const [visibleSuccessBooking, setVisibleSuccessBooking] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const bookingData = useRef({
        bookingId: null,
        bookingCode: null,
        total_price: null,
        service_fee: null,
        travel_fee: null,
        service_name: null,
        ctime: null,
    });

    const textYes = t('Yes', 'Yes');

    const textProceedToBook = t('ProceedToBook', 'Proceed To Book');
    const textReviewMyBookingDetails = t('ReviewMyBookingDetails', 'Review My Booking Details');

    const onCloseSuccessBooking = useCallback(() => {
        setVisibleSuccessBooking(false);
    }, []);

    const handleBooking = () => {
        const fieldsValue = formInstance.getFieldsValue();
        setIsLoading(true);
        fetch({
            method: 'post',
            data: {
                ...fieldsValue,
                scheduled_at: convertDateTimeToUnixTimestamp(`${formInstance.getFieldValue('date')} ${formInstance.getFieldValue('time')}`),
                masseuse_id: parseInt(masseusesId) || formInstance.getFieldValue('masseuse_id'),
                user_lat: formInstance.getFieldValue('lat'),
                user_lng: formInstance.getFieldValue('long'),
                phone_number: fieldsValue?.phone_number,
            },
            url: '/bookings',
        })
            .then((data) => {
                if (data?.code === 0) {
                    bookingData.current = {
                        bookingCode: data?.data?.booking_code,
                        bookingId: data?.data?.booking_id,
                        total_price: data?.data?.total_price,
                        service_fee: data?.data?.service_fee,
                        travel_fee: data?.data?.travel_fee,
                        service_name: data?.data?.service_name,
                        ctime: data?.data?.ctime,
                    };
                    setVisibleSuccessBooking(true);
                } else if (data?.code === 10018) {
                    NotifResult({
                        type: 'info',
                        message: t('PriceHasBeenUpdated', 'Price Has Been Updated'),
                        description: t('PleaseCheckTotalPriceAgain', 'Please Check Total Price Again'),
                    });
                } else if (data?.code === 10008 && data?.message?.includes('guest')) {
                    refreshGuestId().then(() => {
                        handleBooking();
                    });
                } else {
                    NotifResult({
                        type: 'error',
                        message: t('Failed', 'Failed'),
                        description: data?.message,
                    });
                }
            })
            .catch(() => {
                NotifResult({
                    type: 'error',
                    message: t('Failed', 'Failed'),
                    description: t('BookingFailed', 'Booking Failed'),
                });
            })
            .finally(() => setIsLoading(false));
    };
    return (
        <>
            <Drawer visible={visible} onClose={onClose} height={220}>
                <Row style={{ rowGap: 16 }}>
                    <Row style={{ gap: 16 }} wrap={false} align="top">
                        <InfoCircleOutlined style={{ color: 'var(--primary-color)', padding: '8px 0' }} />
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <Text strong style={{ fontSize: 16 }}>
                                Are you sure everything looks good?{' '}
                            </Text>
                            <Text type="secondary" style={{ fontSize: 16 }}>
                                Please double-check your booking information. We want to make sure everything goes smoothly!
                            </Text>
                        </Space>
                    </Row>

                    <Row style={{ rowGap: 16, width: '100%' }}>
                        <Button
                            block
                            loading={isLoading}
                            style={{ width: '100%' }}
                            color="primary"
                            onClick={() => {
                                handleBooking();
                            }}
                        >{`${textYes}, ${textProceedToBook}`}</Button>
                        <Button block loading={isLoading} onClick={() => onClose()} style={{ width: '100%', color: 'var(--primary-color)' }}>
                            {textReviewMyBookingDetails}
                        </Button>
                    </Row>
                </Row>
            </Drawer>
            <ModalSuccessBooking visible={visibleSuccessBooking} onCancel={onCloseSuccessBooking} bookingData={bookingData.current} />
        </>
    );
}

export default BookingConfirmation;
